import { render, staticRenderFns } from "./lockdown.vue.html?vue&type=template&id=3ce7c518"
import script from "./lockdown.controller.ts?vue&type=script&lang=js&external"
export * from "./lockdown.controller.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports